"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NewTab = _interopRequireDefault(require("@paprika/icon/lib/NewTab"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _Item = _interopRequireDefault(require("../../Item.styles"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var bool = _propTypes["default"].bool,
    node = _propTypes["default"].node,
    string = _propTypes["default"].string,
    func = _propTypes["default"].func;
var propTypes = {
  /** HTML for each LinkItem */
  children: node.isRequired,

  /** The url for the href */
  link: string.isRequired,

  /** Callback to be executed when key is pressed */
  onKeyDown: func,

  /** Should the link open content in a new tab */
  isExternal: bool
};
var defaultProps = {
  isExternal: false,
  onKeyDown: function onKeyDown() {}
};

var _StyledA = (0, _styledComponents["default"])("a").withConfig({
  displayName: "LinkItem___StyledA",
  componentId: "nh5hkn-0"
})(["", ""], _Item["default"]);

var LinkItem = function LinkItem(props) {
  var children = props.children,
      onKeyDown = props.onKeyDown,
      isExternal = props.isExternal,
      link = props.link,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "onKeyDown", "isExternal", "link"]);
  var I18n = (0, _useI18n["default"])();

  var linkItemProps = _objectSpread({
    "data-pka-anchor": "overflow-menu.item",
    href: link,
    onKeyDown: onKeyDown,
    role: "menuitem"
  }, moreProps);

  var externalLinkIcon = null;

  if (isExternal) {
    linkItemProps["aria-label"] = I18n.t("overflowMenu.isExternal", {
      link: children
    });
    linkItemProps.target = "_blank";
    linkItemProps.rel = "noopener noreferrer";
    externalLinkIcon = /*#__PURE__*/_react["default"].createElement(_NewTab["default"], {
      size: "10px"
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_StyledA, linkItemProps, children, externalLinkIcon);
};

LinkItem.displayName = "OverflowMenu.LinkItem";
LinkItem.propTypes = propTypes;
LinkItem.defaultProps = defaultProps;
var _default = LinkItem;
exports["default"] = _default;
//# sourceMappingURL=LinkItem.js.map